import React from 'react';

import { PageError } from 'src/pages/error';

interface State {
  hasError: boolean;
}

interface Props {
  children: React.ReactNode;
}

class ErrorBoundary extends React.Component<Props, State> {
  public constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  public static getDerivedStateFromError(): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    /* eslint-disable-next-line no-console */
    console.warn('React component stack:', errorInfo.componentStack);
  }

  public render(): React.ReactNode {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return <PageError />;
    }

    return children;
  }
}

export { ErrorBoundary };
